import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const LotteryResultPage: React.FC = () => {
  const { tagId } = useParams<{ tagId: string }>();
  const [result, setResult] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchResult = async () => {
      try {
        const res = await fetch(`/lottery/result/${tagId}`);
        const data = await res.json();
        setResult(data);
      } catch (err) {
        console.error("Error fetching lottery result:", err);
        setResult(null);
      } finally {
        setLoading(false);
      }
    };
    fetchResult();
  }, [tagId]);

  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center text-white text-2xl bg-gradient-to-br from-blue-400 to-purple-500">
        ⏳ Loading lottery result...
      </div>
    );

  if (!result?.success)
    return (
      <div className="min-h-screen flex flex-col items-center justify-center text-white bg-gradient-to-br from-blue-400 to-purple-500">
        <h1 className="text-4xl font-bold mb-4">🎟️ Lottery Result</h1>
        <p className="text-xl mb-2">Tag ID: {tagId}</p>
        <p className="text-red-300 text-lg">❌ No result found or tag invalid.</p>
      </div>
    );

  const { entry, campaign } = result;
  const won = entry?.status === "winner";

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-400 to-purple-500 flex flex-col items-center justify-center text-white px-6 py-12">
      <h1 className="text-5xl font-bold mb-4">🎟️ Lottery Result</h1>
      <p className="text-xl mb-4">Tag ID: {entry?.tagId}</p>

      {won ? (
        <div className="bg-green-500 text-white rounded-2xl px-8 py-6 shadow-lg">
          <h2 className="text-3xl font-bold mb-2">🎉 Congratulations!</h2>
          <p className="text-lg">You’ve won: {entry?.prize || "Special Reward"} 🏆</p>
        </div>
      ) : (
        <div className="bg-gray-700 text-white rounded-2xl px-8 py-6 shadow-lg">
          <h2 className="text-3xl font-bold mb-2">😞 Better luck next time!</h2>
          <p className="text-lg">You didn’t win this round.</p>
        </div>
      )}

      <div className="mt-8 text-center">
        <p className="text-md text-gray-100">
          Lottery Name: {campaign?.name || "Unknown"}
        </p>
        <p className="text-md text-gray-100">
          Draw Date:{" "}
          {campaign?.drawDate
            ? new Date(campaign.drawDate).toLocaleString()
            : "Pending"}
        </p>
      </div>
    </div>
  );
};

export default LotteryResultPage;
